// src/utils/leaseTypeConstants.js
//
// Canonical lease-type enum values and display labels.
// Single source of truth for both the Locations toolbar (PortfolioView)
// and the Leases toolbar (LeasesPage, src/v2/leases/LeasesPage.jsx).
//
// LEASE_TYPES  — ordered snake_case enum values (matches DB type column).
//                Order is the canonical dropdown order on BOTH surfaces:
//                Direct, Serviced Office, Sublease (In), Sublease (Out).
//                (LSE-LEASES-LANDING-TOOLBAR-ALIGN-FOLLOWUP-2 C5)
// LEASE_DISPLAY — maps each value to a short human label.
//
// LSE-LEASES-LANDING-TOOLBAR-ALIGN-FOLLOWUP: extracted from PortfolioView.jsx
// so both surfaces consume the same constants (no duplication).

export const LEASE_TYPES = [
  "direct_lease",
  "serviced_office",
  "sublease_inbound",
  "sublease_outbound",
];

export const LEASE_DISPLAY = {
  direct_lease:       "Direct",
  sublease_inbound:   "Sublease (In)",
  sublease_outbound:  "Sublease (Out)",
  serviced_office:    "Serviced Office",
};
